/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Hide header on scroll down, show on scroll up
  function initHideOnScrollHeader() {
    const header = document.querySelector('header-component.header__wrapper');
    const innerHeader = header?.querySelector('header');
    if (!header || !innerHeader) return;

    const THRESHOLD = 75;
    let lastY = 0, hidePoint = 0, ticking = false, hidden = false;
    let headerHeight = innerHeader.offsetHeight;

    header.style.transition = 'top .3s ease';

    // Expose header height + state to CSS (sticky chips bar on collections).
    // Rafraîchit aussi headerHeight : figée à la valeur initiale, elle laissait
    // le header partiellement visible (ou trop remonté) après un resize ou un
    // changement d'orientation, puisque `top` utilisait l'ancienne hauteur.
    const setHeaderHeightVar = () => {
      headerHeight = innerHeader.offsetHeight;
      document.documentElement.style.setProperty('--jc-header-h', headerHeight + 'px');
    };
    setHeaderHeightVar();
    window.addEventListener('resize', () => requestAnimationFrame(setHeaderHeightVar), { passive: true });

    function update() {
      const y = window.scrollY;
      const stuck = header.classList.contains('js__header__stuck');

      if (!stuck) {
        if (hidden) { header.style.top = ''; hidden = false; }
        hidePoint = 0;
      } else if (y > lastY) {
        if (!hidePoint) hidePoint = y;
        if (!hidden && y - hidePoint > THRESHOLD) {
          header.style.top = -headerHeight + 'px';
          hidden = true;
        }
      } else if (hidden) {
        header.style.top = '0';
        hidden = false;
        hidePoint = 0;
      }

      document.body.classList.toggle('js__header-stuck', stuck);
      document.body.classList.toggle('js__header-hidden', hidden);

      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  }

  // PDP : description sous le prix — bascule « Lire plus » / « Lire moins » (style Moon Magic)
  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('[data-description-toggle]');
    if (!toggle) return;
    e.preventDefault();
    const wrap = toggle.closest('.product__description--pdp-top');
    if (!wrap) return;
    const closed = wrap.classList.toggle('is-closed');
    toggle.textContent = closed ? toggle.dataset.labelMore : toggle.dataset.labelLess;
  });

  // Masque le lien « Lire plus » quand la description tient déjà en deux lignes.
  // Mesure via scrollHeight (hauteur totale du texte, clampé ou non) contre
  // 2 lignes de 20px, recalculée au resize (le clamp n'existe qu'en desktop).
  function initPdpDescriptionToggle() {
    const blocks = [];
    document.querySelectorAll('.product__description--pdp-top').forEach(function (wrap) {
      const preview = wrap.querySelector('[data-description-preview]');
      const toggle = wrap.querySelector('[data-description-toggle]');
      if (preview && toggle) blocks.push({ preview: preview, toggle: toggle });
    });
    if (!blocks.length) return;

    const update = function () {
      blocks.forEach(function (block) {
        block.toggle.hidden = block.preview.scrollHeight <= 41;
      });
    };
    update();

    // Un seul listener resize partagé, et les noeuds sont résolus une fois :
    // la version précédente enregistrait un listener par bloc de description.
    window.addEventListener('resize', function () { requestAnimationFrame(update); }, { passive: true });
  }

  // ---------------------------------------------------------------------------
  // Megamenu deferral
  //
  // Les panneaux du méga-menu desktop (73 images) et le contenu du tiroir mobile
  // (69 images) pesaient ~250 Ko rendus entre </head> et le premier contenu, sur
  // CHAQUE page. Résultat : sur la home, le <img> du hero se trouvait à l'octet
  // 468 000 d'un document de 1,32 Mo et n'était découvert qu'à 1 566 ms.
  //
  // Les conteneurs restent dans le HTML initial (vides) — indispensable, car
  // <header-megamenu-desktop> n'attache ses écouteurs qu'aux [data-modal-trigger]
  // contenant déjà un [data-modal-container]. Seul le contenu est chargé ici.
  //
  // Stratégie : préchargement dès que le navigateur est inactif (le menu est donc
  // prêt bien avant le premier survol), avec repli sur un fetch immédiat si
  // l'utilisateur interagit avant. En cas d'échec réseau, les liens de premier
  // niveau restent cliquables et les panneaux vides sont masqués en CSS.
  function initMegamenuDeferral() {
    const desktopPanels = document.querySelectorAll('[data-modal-container][data-mm-pending]');
    const mobilePanel = document.querySelector('mobile-menu[data-mm-deferred] [data-mm-mobile-panel]');

    const needsDesktop = desktopPanels.length > 0;
    const needsMobile = !!mobilePanel && mobilePanel.children.length === 0;
    if (!needsDesktop && !needsMobile) return;

    let started = false;
    let desktopInjected = false;
    let mobileInjected = false;
    let desktopWanted = false;
    let mobileWanted = false;

    // Les panneaux ne sont jamais en display:none une fois remplis (le menu
    // desktop est masqué en visibility/max-height, y compris sur mobile) :
    // leurs <img loading="lazy"> partiraient donc en téléchargement dès
    // l'injection en idle — mesuré à ~1,5 Mo d'images de menu sur la home.
    // On injecte le markup sans src/srcset (liens présents dans le DOM, menu
    // structurellement prêt) et on ne rétablit les images qu'à la première
    // interaction avec le menu concerné.
    const stripImages = (rootEl) => {
      rootEl.querySelectorAll('img, source').forEach((el) => {
        ['src', 'srcset'].forEach((attr) => {
          const val = el.getAttribute(attr);
          if (val !== null) {
            el.setAttribute('data-mm-' + attr, val);
            el.removeAttribute(attr);
          }
        });
      });
    };

    const restoreImages = (rootEl) => {
      rootEl.querySelectorAll('[data-mm-src], [data-mm-srcset]').forEach((el) => {
        ['src', 'srcset'].forEach((attr) => {
          const val = el.getAttribute('data-mm-' + attr);
          if (val !== null) {
            el.setAttribute(attr, val);
            el.removeAttribute('data-mm-' + attr);
          }
        });
      });
    };

    const hydrate = async () => {
      if (started) return;
      started = true;

      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(`${root}?section_id=api-megamenu`, { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        stripImages(doc);

        if (needsDesktop) {
          doc.querySelectorAll('[data-api-mm-desktop] [data-mm-panel]').forEach((src) => {
            const target = document.querySelector(
              `[data-modal-container][data-mm-pending][data-mm-panel="${src.dataset.mmPanel}"]`
            );
            if (!target) return;
            target.innerHTML = src.innerHTML;
            // Ne lever le masquage qu'une fois le panneau réellement rempli.
            target.removeAttribute('data-mm-pending');
          });
          desktopInjected = true;
        }

        if (needsMobile) {
          const src = doc.querySelector('[data-api-mm-mobile]');
          if (src) mobilePanel.innerHTML = src.innerHTML;
          mobileInjected = true;
        }
        // Pas de ré-initialisation à faire : le contenu injecté est du markup statique
        // (liens, images, texte) — aucun custom element ni hook data-* à hydrater.

        // L'utilisateur a interagi pendant le fetch : rétablir tout de suite.
        if (desktopWanted) restoreDesktop();
        if (mobileWanted) restoreMobile();
      } catch (err) {
        // Un seul réessai : au-delà, on laisse la navigation de premier niveau faire foi.
        started = false;
        console.warn('[megamenu] chargement différé échoué', err);
      }
    };

    const restoreDesktop = () => {
      desktopWanted = true;
      if (!desktopInjected) {
        hydrate();
        return;
      }
      document.querySelectorAll('[data-modal-container][data-mm-panel]').forEach(restoreImages);
    };

    const restoreMobile = () => {
      mobileWanted = true;
      if (!mobileInjected) {
        hydrate();
        return;
      }
      restoreImages(mobilePanel);
    };

    // Première interaction : rétablir les images du menu concerné (et lancer le
    // fetch s'il n'a pas encore abouti).
    const header = document.querySelector('header-megamenu-desktop');
    ['mouseenter', 'focusin', 'touchstart'].forEach((evt) => {
      if (header) header.addEventListener(evt, restoreDesktop, { once: true, passive: true, capture: true });
    });
    document.querySelectorAll('[data-drawer-toggle], [aria-controls^="custom-mobile-menu"]').forEach((el) => {
      ['mouseenter', 'focusin', 'touchstart'].forEach((evt) =>
        el.addEventListener(evt, restoreMobile, { once: true, passive: true })
      );
    });

    // Préchargement en idle, après le rendu — jamais avant le LCP.
    const schedule = () =>
      'requestIdleCallback' in window
        ? requestIdleCallback(hydrate, { timeout: 3000 })
        : setTimeout(hydrate, 1500);

    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
  }

  // Onglets de collections (section-tab-collections) : seul l'onglet actif est
  // rendu dans le DOM au chargement, les autres arrivent dans des <template>
  // inertes (aucun coût DOM/layout/images au premier rendu — la section pesait
  // 726 Ko de HTML et ~180 images sur la home, soit ~63 % du document).
  // Hydratation en idle après le load, ou immédiatement au premier clic.
  function initTabsDeferral() {
    const deferred = Array.from(document.querySelectorAll('.tab-content[data-tab-deferred]'));
    if (!deferred.length) return;

    const hydrateOne = (panel) => {
      const tpl = panel.querySelector('template[data-tab-template]');
      if (!tpl) return;
      const frag = tpl.content;
      // Le CSS d'entrée AOS masque les éléments (opacity 0) tant que leur
      // animation n'a pas tourné ; injecté après l'init d'AOS, le contenu
      // resterait invisible. On retire les hooks : rendu direct, sans anim.
      frag.querySelectorAll('[data-aos]').forEach((el) => {
        ['data-aos', 'data-aos-anchor', 'data-aos-order', 'data-aos-duration', 'data-aos-easing', 'data-aos-delay'].forEach(
          (attr) => el.removeAttribute(attr)
        );
      });
      panel.appendChild(frag);
      tpl.remove();
      panel.removeAttribute('data-tab-deferred');
    };

    // Clic ou clavier sur un onglet avant l'hydratation en idle : hydrater le
    // panneau visé tout de suite, en capture pour passer avant le script
    // d'onglets du thème.
    document.querySelectorAll('tabs-component .tab-link').forEach((link) => {
      const onActivate = () => {
        const root = link.closest('tabs-component');
        const panel = root && root.querySelector('.tab-content-' + link.dataset.tab + '[data-tab-deferred]');
        if (panel) hydrateOne(panel);
      };
      link.addEventListener('pointerdown', onActivate, { capture: true });
      link.addEventListener('keydown', onActivate, { capture: true });
    });

    const hydrateAll = () => deferred.forEach(hydrateOne);
    const schedule = () =>
      'requestIdleCallback' in window
        ? requestIdleCallback(hydrateAll, { timeout: 4000 })
        : setTimeout(hydrateAll, 2000);

    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
  }

  // Reveal the "back to top" button once the user is well past the first screen
  function initScrollTopButton() {
    const btn = document.querySelector('[data-scroll-top]');
    if (!btn) return;

    const REVEAL_AT = 900;
    const cartBar = document.querySelector('#cart-bar');
    let ticking = false;

    // The sticky add-to-cart bar sits above this button, so lift the button
    // over it whenever the bar has slid into view.
    function cartBarIsOnScreen() {
      if (!cartBar) return false;
      const rect = cartBar.getBoundingClientRect();
      if (rect.height === 0 || rect.top >= window.innerHeight) return false;
      return getComputedStyle(cartBar).visibility !== 'hidden';
    }

    function update() {
      btn.classList.toggle('is-visible', window.scrollY > REVEAL_AT);
      btn.classList.toggle('btn--scroll-top--raised', cartBarIsOnScreen());
      ticking = false;
    }

    if (cartBar) {
      // The bar slides in over 0.3s, so the last scroll frame can read a stale
      // position. Re-check when its state changes and once the slide finishes.
      new MutationObserver(function () {
        update();
        setTimeout(update, 350);
      }).observe(cartBar, { attributes: true, attributeFilter: ['class', 'style'] });
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    btn.addEventListener('click', function () {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });

    update();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initHideOnScrollHeader();
      initPdpDescriptionToggle();
      initMegamenuDeferral();
      initTabsDeferral();
      initScrollTopButton();
    });
  } else {
    initHideOnScrollHeader();
    initPdpDescriptionToggle();
    initMegamenuDeferral();
    initTabsDeferral();
    initScrollTopButton();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
